'use strict';

$.agito = $.agito || {};
$.agito.appendAntyForgeryToken = (function ($) {

    // Get global anti forgery  token
    let aftToken = $('head').attr('data-aft-token');

    // Append token to all ajax requests
    $.ajaxSetup({
        data: {
            __RequestVerificationToken: aftToken
        }
    });

    // Append token to all forms
    $(function () {
        appendAntyForgeryToken($('form'));
    });

    let appendAntyForgeryToken = function ($forms) {
        $forms.each(function (i, form) {
            let $form = $(form);
            if ($form.find('input[name="__RequestVerificationToken"]').length)
                return;

            let $aftInput = $('<input type="hidden" name="__RequestVerificationToken" value="' + aftToken + '" />')

            $aftInput.appendTo($form);
        });
    }

    return appendAntyForgeryToken;

})($);